import {
    defaultBaseQuery,
    transformErrorResponse,
    transformRequest,
    transformSuccessResponse
} from '@/services';
import { createApi } from '@reduxjs/toolkit/query/react';

const skillmasterapi = createApi({
    baseQuery: defaultBaseQuery,
    reducerPath: 'skillmasterapi',
    endpoints: (builder) => ({

        getSkillMasterList: builder.query({
            query: () => ({
                url: '/student/skill-category/dropdown?name=SKILLS',
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        addSkillMaster: builder.mutation({
            query: (data) => ({
                url: '/student/skill-category/add',
                method: 'POST',
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        deleteSkillCategory: builder.mutation({
            query: (categoryId) => ({
                url: `/skill-category/delete?categoryId=${categoryId}`,
                method: 'DELETE'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        deleteSubSkillFromCategory: builder.mutation({
            query: (subSkillId) => ({
                url: `/student/skill-category/remove?skillId=${subSkillId}`,
                method: 'DELETE'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

    }),
});

export const {
    useLazyGetSkillMasterListQuery,
    useAddSkillMasterMutation,
    useDeleteSkillCategoryMutation,
    useDeleteSubSkillFromCategoryMutation,
} = skillmasterapi;

export default skillmasterapi;
